import {
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles"
import React, { useMemo } from "react"

import customShadows from "./customShadows"
import componentsOverride from "./overrides"
import palette from "./palette"
import { SettingsProvider, ThemeSettings, useSettingsContext } from "./settings"
import shadows from "./shadows"
import typography from "./typography"

export default function ThemeProvider({
  children,
  applyGlobalStyle = false,
  disableMode = false,
}: {
  children: React.ReactNode
  applyGlobalStyle?: boolean
  disableMode?: boolean
}): JSX.Element {
  return (
    <SettingsProvider>
      <Theme applyGlobalStyle={applyGlobalStyle} disableMode={disableMode}>
        {children}
      </Theme>
    </SettingsProvider>
  )
}

function Theme({
  children,
  applyGlobalStyle = false,
  disableMode = false,
}: {
  children: React.ReactNode
  applyGlobalStyle: boolean
  disableMode?: boolean
}): JSX.Element {
  const { themeMode } = useSettingsContext()

  const themeOptions = useMemo(
    () => ({
      palette: palette(themeMode),
      typography,
      shape: { borderRadius: 8 },
      shadows: shadows(themeMode),
      customShadows: customShadows(themeMode),
    }),
    [themeMode]
  )

  const theme = createTheme(themeOptions)

  theme.components = componentsOverride(theme)

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <ThemeSettings applyGlobalStyle={applyGlobalStyle} disableMode={disableMode}>
          {children}
        </ThemeSettings>
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
}
